"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _componentDataParser = _interopRequireDefault(require("../js/component-data-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
   *
   * @param {HTMLElement} element
   * @returns {Object}
   */
var getComponentElement = function getComponentElement(element) {
  var output = {};
  output.classes = _toConsumableArray(element.classList);
  output.html = _componentDataParser["default"].getComponentHtml(element);
  output.specificTag = element.getAttribute('data-tag');
  output.type = 'text';

  if (element.classList.contains('element__item__link') || element.classList.contains('pre-element__item__link') || element.classList.contains('post-element__item__link')) {
    output.link = _componentDataParser["default"].getComponentLink(element.querySelector('a'));
    output.type = 'link';
  }

  if (element.classList.contains('element__item__image') || element.classList.contains('pre-element__item__image') || element.classList.contains('post-element__item__image')) {
    output.image = _componentDataParser["default"].getComponentImage(element.querySelector('img'));
    output.type = 'image';
  }

  if (element.classList.contains('element__item__video') || element.classList.contains('pre-element__item__video') || element.classList.contains('post-element__item__video')) {
    output.video = _componentDataParser["default"].getComponentIframe(element.querySelector('iframe'));
    output.type = 'video';
  }

  output.tag = element.getAttribute('data-tag');
  return output;
};

var getObjectFromData = function getObjectFromData(elements) {
  var elementsObject = {};
  elements.map(function (element) {
    if (element.children.length || element.textContent.length) {
      var elementData = getComponentElement(element);

      if (elementsObject[elementData.specificTag]) {
        var arrData = Array.isArray(elementsObject[elementData.specificTag]) ? elementsObject[elementData.specificTag] : [elementsObject[elementData.specificTag]];
        arrData.push(elementData);
        elementsObject[elementData.specificTag] = arrData;
      } else {
        elementsObject[elementData.specificTag] = elementData;
      }
    }
  });
  return elementsObject;
};
/**
   *
   * @param {Array.<HTMLElement>} elements
   * @returns {Array.<Object>}
   */


var getComponentElementList = function getComponentElementList(elements) {
  return getObjectFromData(elements);
}; // const getComponentElementList = (elements) => { console.log('elements', elements); return []; };


var _default = [{
  name: 'numCols',
  parser: function parser(component) {
    return component.getAttribute('data-num-cols');
  }
}, {
  name: 'preElementItems',
  elements: '.pre-element__item',
  parser: function parser(elementList) {
    return getComponentElementList(elementList);
  }
}, {
  name: 'elements',
  elements: '.element',
  parser: function parser(elements) {
    var output = [];
    elements.forEach(function (element) {
      output.push(getComponentElementList(Array.from(element.querySelectorAll('.element__item'))));
    });
    return output;
  }
}, {
  name: 'postElementItems',
  elements: '.post-element__item',
  parser: function parser(elementList) {
    return getComponentElementList(elementList);
  }
}];
exports["default"] = _default;